import { gql } from '@apollo/client'

export const TrackCount = gql`
    query TrackCount($roomId: ID, $tags: String!) {
        trackCount(roomId: $roomId, tags: $tags)
    }
`

export default TrackCount

